import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ConsultaIndividualTab from "./components/consulta-individual-tab";
import InutilizacaoTab from "./components/inutilizacao-tab";

const MigrateTab = () => {
  return (
    <Tabs defaultValue="consulta-individual" className="w-full">
      <TabsList className="mb-6 bg-gray-100 p-1 border border-gray-200">
        <TabsTrigger
          value="consulta-individual"
          className="data-[state=active]:bg-white data-[state=active]:shadow-sm"
        >
          Consulta Individual
        </TabsTrigger>
        <TabsTrigger
          value="inutilizacao"
          className="data-[state=active]:bg-white data-[state=active]:shadow-sm"
        >
          Inutilização
        </TabsTrigger>
      </TabsList>

      <TabsContent value="consulta-individual">
        <ConsultaIndividualTab />
      </TabsContent>

      <TabsContent value="inutilizacao">
        <InutilizacaoTab />
      </TabsContent>
    </Tabs>
  );
};

export default MigrateTab;
